
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect } from '@/components';
import { AppFileUpload, AppImageHolder, AppSwitch, AppButton } from '@/components';
import { useShopItemEdit } from '@/modules/shop/model/edit';
import { renderOption } from '@/common/utils/helpers';
import { ROUTE_NAME_SHOP } from '@/modules/shop/router';
import { ShopItemType, Options } from '@/modules/shop/model/mixins';

export default defineComponent({
    name: ROUTE_NAME_SHOP.EDIT,
    components: { AppFormRow, AppInput, AppSelect, AppCard, AppFileUpload, AppImageHolder, AppSwitch, AppButton },
    setup() {
        const { model, v$, actions, iapOptions } = useShopItemEdit();

        return { v$, model, iapOptions, actions, renderOption, ShopItemType, Options, ROUTE_NAME_SHOP };
    }
});
